<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header
        :entity="$entitiesName.PaymentType"
        :edit="edit"
        :save="save"
        :cancel="cancel"
      >
        <h1 class="title">
          <breadcrumb
            location="/paymenttypes"
            :text="$t('entities.paymentType')"
          ></breadcrumb>
          {{ paymenttype.name }}
        </h1>
      </page-header>
      <div class="panel">
        <div class="panel-heading has-background-primary">
          <span>{{ $t("common.information") }}</span>
        </div>
        <div class="panel-block is-block no-border">
          <div class="columns" v-if="paymenttype.id">
            <div class="column is-half" v-if="paymenttype">
              <field readonly :label="$t('common.name')">
                {{ paymenttype.name }}
              </field>
              <text-field
                :label="$t('common.oracleCode')"
                v-model="paymenttype.oracleCode"
                required
              ></text-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

    <script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "PaymentType",
  props: ["id"],
  data() {
    return {
      paymenttype: {
        name: null,
        oracleCode: null,
        id: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      editMode: "states/isEdition",
      getRights: "auth/getRights",
      user: "auth/getUser",
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return axios.get(`/payment_type/${this.id}`).then((r) => {
        this.paymenttype = r.data;
      });
    },
    remove() {
      return this.$awn.confirm(
        "Êtes-vous sûr de vouloir supprimer cet élément ?",
        () =>
          axios
            .delete(`/payment_type/${this.id}`, this.paymenttype)
            .then((response) => {
              if (response.data.success) {
                this.$router.replace("/paymenttypes");
              }
            })
      );
    },
    save() {
      return this.$validator.validateAll().then((result) => {
        if (result) {
          return axios
            .put(`/payment_type/${this.id}`, this.paymenttype)
            .then((response) => {
              if (response.data) {
                this.paymenttype = response.data;
                this.cancel();
              }
            });
        }
        return Promise.resolve();
      });
    },
    edit() {
      this.$store.dispatch("states/setEdition", true);
    },
    cancel() {
      this.fetchData().then(() => {
        this.$store.dispatch("states/setEdition", false);
      });
    },
  },
};
</script>
